/**
 * BMR Calculator
 */
export default class BmrCalculator {
	constructor() {
		/**
		 * DOM Selectors
		 * @type {{acceptAllLabel: string, bmrCalculate: string, acceptLabel: string}}
		 */
		this.DOM = {
			bmrCalculate: ".c-bmr-calculator",
		};

		this.bmrCalculate = document.querySelector(this.DOM.bmrCalculate);
	}

	/**
	 * Init
	 */
	init() {
		if (this.bmrCalculate === null) {
			return;
		}
		this.bmrCalc();
	}

	/**
	 * Calculate BMR
	 */
	bmrCalc() {
		var height = document.getElementById("height");
		var weight = document.getElementById("weight");
		var age = document.getElementById("age");
		var form = document.getElementById("form");

		function validateForm() {
			if (height.value == '' || weight.value == '') {
				document.getElementById("submit").removeEventListener("click", countBmr);
			} else {
				countBmr();
			}
		}

		document.getElementById("submit").addEventListener("click", validateForm);

		function countBmr() {
			var p = [height.value, weight.value, age.value];
			var graphRotateEl = document.getElementById('bmr_calc_arrow');
			var gender = document.querySelector('.c-form__fieldset--radio input[name="gender"]:checked').value;

			if (gender === 'm') {
				var bmr = 66 + 13.7 * Number(p[1]) + 5 * Number(p[0]) - 6.8 * Number(p[2]);
				var rmr = 0.3281 * Number(p[1]) + 0.33929 * Number(p[0]) - 29.5336;
			} else {
				var bmr = 655 + 9.6 * Number(p[1]) + 1.8 * Number(p[0]) - 4.7 * Number(p[2]);
				var rmr = 0.29569 * Number(p[1]) + 0.41813 * Number(p[0]) - 43.2933;
			}

			var bmrResult = parseFloat(bmr).toFixed(2);
			var rmrResult = parseFloat(rmr).toFixed(2);

			if (bmr > 4000) {
				var degree = 172;
			} else if (bmr < 100) {
				var degree = 8;
			} else {
				var degree = bmr / 3900 * 180;
			}

			document.getElementById('bmr_calc_result').innerHTML = bmrResult;
			document.getElementById('rmr-result').innerHTML = rmrResult;
			graphRotateEl.style.webkitTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.mozTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.msTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.oTransform = 'rotate(' + degree + 'deg)';
			graphRotateEl.style.transform = 'rotate(' + degree + 'deg)';
		}
	}
}
